import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CashNowService } from '@app/services/cash-now.service';
import { ModalService } from '@app/services/modal.service';
import { SubjectService } from '@app/services/subject.service';
import { UserModel } from '@models/user.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import Swal from "sweetalert2";

@Component({
  selector: 'app-cash-now-factoring',
  templateUrl: './cash-now-factoring.component.html',
  styleUrls: ['./cash-now-factoring.component.scss']
})
export class CashNowFactoringComponent implements OnInit {

  public identity: UserModel;
  public link: string = environment.cashNowMicrofrontUrl;
  public url: SafeResourceUrl;

  private confirmationSubject: Subject<boolean> = new Subject<boolean>();

  @ViewChild('iframe') iframe: ElementRef;

  constructor(
    private domSanitizer: DomSanitizer,
    private cashNow: CashNowService,
    private modal: ModalService,
    private subject: SubjectService,
    public router: Router,
    public spinner: NgxSpinnerService,
  ) {
    this.getIdentity();
    this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(this.link);
  }

  ngOnInit() {
    this.subject.headerCollapse(true);
    this.handleRenderCashNowFromAffiliate(this.identity);
  }

  getIdentity() {
    return (this.identity = UserModel.fromResponse(
      JSON.parse(sessionStorage.getItem('user'))
    ));
  }

  handleRenderCashNowFromAffiliate(affiliate: UserModel) {
    try {
      let { user, documentType, document } = affiliate.userInfo;
      this.link = `${environment.cashNowMicrofrontUrl}?numeroDocumento=${document}&tipoDocumento=${documentType}&usuario=${user}`;

      this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(this.link);

    } catch (error) {
      this.errorAlert('acceder a la página', error);
    }
  }

  errorAlert(message: string, error: any) {
    Swal.fire({
      type: "error",
      title: `No se pudo ${message}`,
      text: error ? error : "Por favor intente más tarde",
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    this.spinner.show();
    return this.getBillsChecked().pipe(
      switchMap(response => {
        this.spinner.hide();
        if (response > 0) {
          this.modal.show("exitCurrentPage");
          return this.confirmationSubject.asObservable();
        }
        return of(true);
      }),
      catchError(error => {
        console.error(error);
        this.spinner.hide();
        return of(true);
      })
    );
  }

  getBillsChecked(): Observable<number> {
    const { documentType, document } = this.identity.userInfo;
    const body = {
      "tipoDocumento": documentType,
      "numeroDocumento": document,
      "query": "",
      "by": "none",
      "currentPage": 1,
      "perPage": 1
    };

    return this.cashNow.getBills(body).pipe(
      map((response: number) => {
        return response;
      }),
      catchError(error => {
        console.error(error);
        return of(0)
      })
    );
  }

  closeCashNowPage(value: boolean) {
    this.confirmationSubject.next(value);
  }

  ngOnDestroy() {
    this.subject.headerCollapse(false);
    this.confirmationSubject.next();
    this.confirmationSubject.complete();
  }
}